<template>
    <v-card class="mb-6">
        <v-list-item-subtitle>Traveller details</v-list-item-subtitle>
        <v-card-text>
          <ValidatedInput
            name="First name"
            v-model="firstName"
            :labelValue="'First name'"
            append-icon="mdi-card-bulleted-outline"
            :placeholderValue="'Enter your first name'"
            :maxlength="50"
            rules="required"
            required>
          </ValidatedInput>
          <ValidatedInput
            name="Last name"
            v-model="lastName"
            :labelValue="'Last name'"
            append-icon="mdi-card-bulleted-outline"
            :placeholderValue="'Enter your last name'"
            rules="required"
            :maxlength="50"
            required>
          </ValidatedInput>
          <ValidationProvider
            name="Mobile Number"
            :rules="{ required: !emailAddress }"
            v-slot="{errors}" slim>
            <vue-tel-input-vuetify
              ref="mobileInput"
              v-model="mobileNumber"
              label="Mobile number"
              placeholder="Enter a mobile number"
              hint="If outside Australia, choose your country"
              @onInput="validateMobile"
              mode="international"
              :error-messages="phoneErrors"
              defaultCountry="AU"
              clearable
              maxlength="50">
            </vue-tel-input-vuetify>
            <span class="mobile-validator">{{ errors[0] }}</span>
          </ValidationProvider>
          <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="{ errors }">
            <v-checkbox
              v-show="false"
              v-model="mobileNumberIsValid">
            </v-checkbox>
          </ValidationProvider>
          <v-text-field
              v-model="phoneNumber"
              label="Phone number"
              append-icon="mdi-phone"
              maxlength="50"
              counter>
          </v-text-field>
          <ValidationProvider
            name="Email"
            :rules="`${!mobileNumber ? 'required' : ''}`"
            v-slot="{errors}" slim>
            <v-text-field
                v-model="emailAddress"
                label="Email"
                append-icon="mdi-email"
                type="email"
                :error-messages="errors"
                maxlength="50"
                counter>
            </v-text-field>
          </ValidationProvider>
        </v-card-text>
    </v-card>
</template>

<script>
import { mask } from 'vue-the-mask';
import { mapFields } from 'vuex-map-fields';
import
{
  extend,
  ValidationProvider,
} from 'vee-validate';
/* eslint-disable camelcase */
import { regex, required_if } from 'vee-validate/dist/rules';
/* eslint-enable camelcase */
import ValidatedInput from '@/components/ValidatedInput.vue';

extend('regex', regex);
extend('required_if', required_if);

export default {
  name: 'TravellerDetails',
  components: {
    ValidationProvider,
    ValidatedInput,
  },
  props: {
    bookingId: {
      type: Number,
      default: undefined,
    },
    customerId: {
      type: Number,
      default: undefined,
    },
  },
  directives: {
    mask,
  },
  computed: {
    // The `mapFields` function takes an array of
    // field names and generates corresponding
    // computed properties with getter and setter
    // functions for accessing the Vuex store.
    ...mapFields([
      'booking.firstName',
      'booking.lastName',
      'booking.mobileNumber',
      'booking.phoneNumber',
      'booking.emailAddress',
      'booking.communicationType',
    ]),
  },
  mounted() {
    this.mobileNumberIsValid = true;
  },
  methods: {
    validateMobile(response) {
      this.mobileNumberIsValid = response.isValid || response.number.input.length === 0;
      if (response.isValid || response.number.input.length === 0) {
        this.phoneErrors = [];
      } else if (response?.number?.input.startsWith('049') && response.number.input.length === 10) {
        this.phoneErrors = [];
        this.mobileNumberIsValid = true;
      } else {
        this.phoneErrors = [
          'Please enter a valid mobile number',
        ];
      }
    },
  },
  data: () => ({
    phoneErrors: [],
    mobileNumberIsValid: true,
    communicationTypes: [
      { value: 1, text: 'Sms' },
      { value: 3, text: 'Email' },
      { value: 4, text: 'Both' },
    ],
  }),
};
</script>
<style scoped>
  span.mobile-validator {
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
    line-height: 12px;
    word-break: break-word;
    overflow-wrap: break-word;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    font-size: 12px;
    min-height: 14px;
    min-width: 1px;
    position: relative;
  }
</style>
